import { DNSRecord, DNSRecordType, DNSZoneStatus } from '@fenix/dns-entities';
import { DepartmentInterface } from '../../Departments/Interfaces';

export default interface DNSRepositoryInterface {
  getAllZones(): Promise<DNSZonesInterface[]>;

  // getClientZones(clientId: number): Promise<DNSZonesInterface[]>

  getZones(domain: string): Promise<DNSZonesInterface>;

  createDNSZone(newDnsZone: CreateDNSZonesInterface): Promise<void>;

  deleteDNSZone(id: number): Promise<boolean>;

  updateDNSZoneVisibility(zoneId: number, adminOnly: boolean): Promise<void>;

  getDNSZoneRecords(zoneId: number): Promise<DNSRecordsInterface[]>;

  createDNSRecord(id: number, record: DNSRecord): Promise<boolean>;

  deleteDNSRecord(id: number, recordId: number): Promise<boolean>;

  searchZones(search: string): Promise<DNSZonesInterface[]>;

  getDepartments(): Promise<string[]>;

  demoteDepartment(departmentId: string): Promise<void>;

  promoteDepartment(departmentId: string): Promise<void>;

  syncDNS(domain?: string, server?: string, step?: number): Promise<void>;

  activateDNSZone(zoneId: number): Promise<void>;
}

export interface DNSZonesInterface {
  id: number;
  domain: string;
  websiteId: number;
  status: DNSZoneStatus;
  adminOnly: boolean;
  installation: DNSZoneInstallation;
}

export interface DNSZoneInstallation {
  domain: string;
  dnsIP: string;
  server: string;
}

export interface CreateDNSZonesInterface {
  server: string;
  websiteId: number;
  adminOnly: boolean;
}

export interface DNSRecordContentInterface {
  ttl: number;
  host: string;
  type: DNSRecordType;
  target: string;
  priority?: number;

  // SOA fields
  neg_cache_ttl?: number;
  serial_number?: number;
  retry_interval?: number;
  expire_interval?: number;
  refresh_interval?: number;
  responsible_domain?: string;

  // CAA fields
  flag?: number;
  tag?: string;
}

export interface DNSRecordsInterface {
  id: number;
  target: string;
  type: DNSRecordType;
  content: DNSRecordContentInterface;
  status: string;
  createdAt: string;
}

export enum CAAFlag {
  IssuerCritical = 1 << 7,
}

export enum CAARecordTag {
  ISSUE = 'issue',
  ISSUE_WILD = 'issuewild',
  IODEF = 'iodef',
}

export class CAARecord extends DNSRecord {
  public type: DNSRecordType = "CAA" as DNSRecordType;
  public flag: number;
  public tag: CAARecordTag;

  constructor(
    tag: CAARecordTag,
    id?: number,
    host?: string,
    ttl?: number,
    target?: string,
    flag?: number,
  ) {
    super(id, host, ttl, target);

    this.flag = flag ?? 0;
    this.tag = tag;
  }

  public getContent(): string {
    return `${this.flag} ${this.tag} "${this.target}"`;
  }
}
